<template>
  <v-container fluid grid-list-lg>
    <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
      <v-toolbar>
        <v-icon>thumbs_up_down</v-icon>
        <v-toolbar-title v-if="!user.esComer" class="font-weight-light"
          >&nbsp;Análisis de
          {{ solicitud.estadoId >= 5 ? "Solicitud" : "Consulta" }} de
          Crédito</v-toolbar-title
        >
        <v-toolbar-title v-else class="font-weight-light"
          >&nbsp;Detalle de Consulta de Crédito</v-toolbar-title
        >
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-layout column>
            <v-flex xs12>
              <v-card dark color="purple">
                <v-card-actions>
                  <div>{{ solicitud.infoCanalVenta }}</div>
                  <v-spacer></v-spacer>
                  <v-tooltip
                    bottom
                    v-if="
                      !user.esComer &&
                      !user.esComercio &&
                      solicitud.estadoId >= 5
                    ">
                    <template v-slot:activator="{}">
                      <v-btn
                        fab
                        dark
                        x-small
                        @click="showModificarCanalVenta = true">
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Modificar</span>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card dark color="green darken-3">
                <v-card-actions>
                  <div>{{ solicitud.infoPersona }}</div>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card dark color="blue ligthten-3">
                <v-card-actions>
                  <div>{{ solicitud.infoEmpleo }}</div>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card dark color="blue ligthten-3">
                <v-card-actions>
                  <div>{{ solicitud.infoCredito }}</div>
                  <v-spacer></v-spacer>
                  <v-tooltip
                    bottom
                    v-if="
                      !user.esComer &&
                      !user.esComercio &&
                      solicitud.estadoId >= 5
                    ">
                    <template v-slot:activator="{}">
                      <v-btn fab dark x-small @click="showModificarPlan = true">
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Modificar</span>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-flex>
            <!-- lo oculto para los usuarios comer sin cupo -->
            <v-flex
              xs12
              v-if="
                !(
                  this.user.esComer && this.user.modalidadAltaConsultaId == 2
                ) && solicitud.infoMotor
              ">
              <v-card color="orange ligthten-3">
                <v-card-actions>
                  <div>{{ solicitud.infoMotor }}</div>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex xs12 v-if="mostrarVerLogProductoDirigido">
              <div>
                <v-btn color="purple" @click="showLogProductoDirigido = true"
                  >Ver Auditoría Producto Dirigido</v-btn
                >
              </div>
            </v-flex>

            <v-flex xs12 v-if="solicitud.linkFirmaDigital">
              <app-link-gueno
                :info="solicitud.linkFirmaDigital"
                :solicitudId="solicitud.id"></app-link-gueno>
            </v-flex>

            <!-- {{ $store.state.parametrosGenerales.linkGuenoVisiblePara }}
            {{ user.esComer }}
            {{ user.esOnline }}
            {{ user.esComercio }}
            {{ user.esConcentrador }} -->
            <v-flex
              xs12
              v-if="
                solicitud.linkGueno && checkCanAccess('ap-mostrar-link-gueno')
              ">
              <app-link-gueno
                :info="solicitud.linkGueno"
                :solicitudId="solicitud.id"></app-link-gueno>
            </v-flex>

            <v-flex
              xs12
              v-if="
                solicitud.linkDigiventures &&
                checkCanAccess('ap-mostrar-link-gueno')
              ">
              <app-link-digiventures
                :info="solicitud.linkDigiventures"
                :solicitudId="solicitud.id"></app-link-digiventures>
            </v-flex>

            <v-flex xs12 v-if="solicitud.linkCargaRapidaComer">
              <v-card flat>
                <v-card-actions>
                  <div>
                    <app-link-carga-rapida-comer
                      :info="
                        solicitud.linkCargaRapidaComer
                      "></app-link-carga-rapida-comer>
                  </div>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex
              xs12
              v-if="
                solicitud.linkCardCredDebito || solicitud.linkCardCredCredito
              ">
              <div>
                <app-link-cardcred
                  v-if="solicitud.linkCardCredDebito"
                  :info="solicitud.linkCardCredDebito"
                  :solicitudId="solicitud.id"></app-link-cardcred>
              </div>
              <div>
                <app-link-cardcred
                  v-if="solicitud.linkCardCredCredito"
                  :info="solicitud.linkCardCredCredito"
                  :solicitudId="solicitud.id"></app-link-cardcred>
              </div>
            </v-flex>

            <div class="caption pink--text">
              Renovación Anticipada
              <v-chip
                dark
                color="pink"
                label
                @click="buscarCreditosParaRenovar()"
                small
                >Buscar Créditos en Condiciones</v-chip
              >

              <v-container
                fluid
                grid-list-lg
                v-if="creditosARenovar && creditosARenovar.length > 0">
                <v-row
                  v-for="item in creditosARenovar"
                  :key="item.numero"
                  dense
                  align="center">
                  <v-col cols="6">
                    <span
                      >Crédito No. {{ item.numero }} de {{ item.origen }}</span
                    >
                  </v-col>
                  <v-col>
                    <v-chip
                      dark
                      color="indigo"
                      label
                      @click="calcularRenovacion(item.id)"
                      small
                      >Saldo a Renovar:
                      {{ item.totalARenovar | currency }}</v-chip
                    >
                  </v-col>
                </v-row>
              </v-container>
            </div>

            <v-flex xs12>
              <app-lista-log-acciones-credito
                :list="solicitud.log"
                :loading="loading"
                titulo="Log de Acciones sobre la Consulta"></app-lista-log-acciones-credito>
            </v-flex>

            <!-- <v-flex xs12>
                        <gestiones-debitos-persona :personaId="solicitud.personaId" v-on:loading-changed="loading = $event"> </gestiones-debitos-persona>
                    </v-flex> -->

            <v-flex xs12>
              <v-row dense>
                <v-col>
                  <div class="title" v-if="!user.esComer && !user.esComercio">
                    Resultado del Análisis
                  </div>
                </v-col>
                <v-spacer></v-spacer>
                <v-col
                  v-if="!user.esComer && !user.esComercio && motorSiisaActivo"
                  cols="2">
                  <v-btn x-small color="orange" @click="reevaluar = !reevaluar"
                    >Reevaluar x Motor</v-btn
                  >
                </v-col>
              </v-row>

              <v-flex xs12 v-if="reevaluar">
                <v-card>
                  <v-card-text>
                    <div class="body-1">Reevaluación x Motor</div>
                    <v-row align="center" dense>
                      <v-col>
                        <v-autocomplete
                          v-model="reevaluacion.entidadFinancieraId"
                          :items="listEntidadesFinancieras"
                          autocomplete="disabled"
                          item-text="descripcion"
                          item-value="id"
                          label="Banco"
                          :menu-props="{ minWidth: '200' }"></v-autocomplete>
                      </v-col>

                      <v-col>
                        <v-autocomplete
                          v-model="reevaluacion.productoId"
                          :items="listProductosDisponibles"
                          autocomplete="disabled"
                          item-text="productoDescripcion"
                          item-value="productoId"
                          label="Producto Asignado"
                          :menu-props="{ minWidth: '200' }"></v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row align="center" dense>
                      <v-col cols="3">
                        <v-text-field
                          label="Ingreso Neto Mensual"
                          v-model="reevaluacion.ingresoMensual"></v-text-field>
                      </v-col>

                      <v-col cols="3">
                        <v-text-field
                          label="Movimientos"
                          v-model="reevaluacion.movimientos"></v-text-field>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="2">
                        <v-btn
                          x-small
                          @click="reevaluarxMotor"
                          :disabled="loadingMotor"
                          >Enviar a Motor
                          <v-progress-circular
                            x-small
                            v-if="loadingMotor"
                            indeterminate
                            size="24"
                            color="green"></v-progress-circular
                        ></v-btn>
                      </v-col>
                    </v-row>

                    <v-alert
                      dark
                      color="blue"
                      v-if="model.consultaCredito !== null">
                      <div>{{ infoconsultaCredito }}</div>
                    </v-alert>

                    <app-info-consulta-motor-siisa
                      :consultaCredito="model.consultaCredito"
                      v-if="
                        model.consultaCredito !== null
                      "></app-info-consulta-motor-siisa>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-row>
                <v-col cols="6" lg="4">
                  <v-select
                    v-if="!user.esComer && !user.esComercio"
                    label="Pasar Consulta a:"
                    item-text="descripcion"
                    item-value="id"
                    return-object
                    v-model="selectedSubEstado"
                    :items="listaSubEstados"
                    no-data-text="No hay Estados disponibles"></v-select>
                </v-col>

                <v-col v-if="estadoAsignaCupo && !pasaAAprobado">
                  <v-alert color="info" dark small>
                    La solicitud no se originó en una consulta, por lo que no
                    puede asignarse un Cupo
                  </v-alert>
                </v-col>

                <v-col cols="2" v-if="pasaAAprobado">
                  <v-text-field label="Cupo" v-model="cupo"></v-text-field>
                </v-col>
                <v-col cols="2" v-if="pasaAAprobado">
                  <v-text-field
                    label="Monto Máximo"
                    v-model="topeProducto"></v-text-field>
                </v-col>

                <v-col v-if="pasaAAprobado" cols="2">
                  <v-autocomplete
                    v-model="solicitud.situacionCreditoId"
                    :items="listSituacionesCredito"
                    autocomplete="disabled"
                    item-text="descripcion"
                    item-value="id"
                    label="Genera Crédito"
                    :menu-props="{ minWidth: '200' }"></v-autocomplete>
                </v-col>

                <v-col
                  cols="2"
                  v-if="
                    pasaAAprobado && solicitud.requiereIngresoCargosServicio
                  ">
                  <v-text-field
                    label="Cargos Servicio (1412)"
                    v-model="cargosDirectos"></v-text-field>
                </v-col>

                <v-col
                  v-if="pasaAAprobado && solicitud.situacionCreditoId == 3"
                  cols="2">
                  <v-text-field
                    label="Importe Renovación"
                    v-model="solicitud.importeRenovacion"></v-text-field>
                </v-col>

                <!-- <v-col v-if="pasaAAprobado && solicitud.infoCanalVenta.includes('AMTAE')" cols="2">
                                <v-text-field  label="Importe Retencion" v-model="solicitud.importeRetencion"></v-text-field>
                            </v-col> -->

                <v-col v-if="pasaARechazado" cols="4">
                  <v-autocomplete
                    v-model="solicitud.motivoRechazoId"
                    :items="listMotivosRechazo"
                    autocomplete="disabled"
                    item-text="descripcion"
                    item-value="id"
                    label="Motivo de Rechazo"
                    :menu-props="{ minWidth: '200' }"></v-autocomplete>
                </v-col>

                <v-col v-if="pasaALiquidado" cols="4">
                  <v-autocomplete
                    v-model="solicitud.tipoLegajoId"
                    :items="listTiposLegajo"
                    autocomplete="disabled"
                    item-text="nombre"
                    item-value="id"
                    label="Tipo Legajo"
                    :menu-props="{ minWidth: '200' }"></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-if="pasaAAprobado" cols="6">
                  <v-autocomplete
                    v-model="solicitud.productoId"
                    :items="listProductosDisponibles"
                    autocomplete="disabled"
                    item-text="productoDescripcion"
                    item-value="productoId"
                    label="Producto Asignado"
                    :menu-props="{ minWidth: '200' }"></v-autocomplete>
                  <!-- @change="selectedProductoChanged"                           -->
                </v-col>
                <v-col v-if="pasaAAprobado" cols="6">
                  <v-autocomplete
                    v-model="solicitud.planId"
                    :items="listPlanesDisponibles"
                    autocomplete="disabled"
                    item-text="planNombre"
                    item-value="planId"
                    label="Plan Asignado"
                    :menu-props="{ minWidth: '200' }"></v-autocomplete>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="8">
                  <v-textarea
                    label="Ingresar comentarios"
                    v-model="comentarios"></v-textarea>
                </v-col>
                <v-spacer></v-spacer>
                <v-col>
                  <v-btn color="info" @click="enviarComentarios"
                    >Enviar Comentarios &nbsp;<v-icon>comment</v-icon></v-btn
                  >
                </v-col>
              </v-row>

              <v-row>
                <v-spacer></v-spacer>
                <v-flex xs4>
                  <v-btn
                    :disabled="!puedeVolverAtras"
                    v-if="
                      checkCanAccess('ap-volver-subestado-anterior') &&
                      !solicitudAnuladaORechazada
                    "
                    color="warning"
                    @click="reactivarCredito"
                    >Volver a Subestado Anterior</v-btn
                  >
                </v-flex>
                <v-flex xs4>
                  <v-btn
                    :disabled="!tieneRol"
                    v-if="
                      checkCanAccess('ap-reactivar-credito') &&
                      solicitudAnuladaORechazada
                    "
                    color="warning"
                    @click="reactivarCredito"
                    >Reactivar Credito</v-btn
                  >
                </v-flex>
              </v-row>
              <v-layout>
                <v-flex xs4>
                  <v-btn
                    v-if="!user.esComer && !user.esComercio"
                    color="cancel"
                    @click="cancelar"
                    >Cancelar Análisis</v-btn
                  >
                  <v-btn v-else color="cancel" @click="cancelar">Salir</v-btn>
                </v-flex>
                <v-flex xs4>
                  <v-btn
                    v-if="
                      !tomadoPorOtroUsuario && !user.esComer && !user.esComercio
                    "
                    color="cancel"
                    @click="cancelarYMantener"
                    >Cancelar y Mantener Caso</v-btn
                  >
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs6>
                  <v-btn
                    :disabled="tomadoPorOtroUsuario"
                    v-if="
                      !user.esComer && !(estadoAsignaCupo && !pasaAAprobado)
                    "
                    block
                    color="success"
                    @click="confirmar">
                    <div v-if="!tomadoPorOtroUsuario">
                      Confirmar Cambio de Estado
                    </div>
                    <div v-else>Tomado por Otro Usuario</div>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>

    <!-- Modificar Canal de Venta  -->
    <v-dialog v-model="showModificarCanalVenta" width="600" persistent>
      <app-modificador-canalventa-credito
        :Solicitud="solicitud"
        :Ok="modificacionOk"
        :Cancel="modificacionCancelada">
      </app-modificador-canalventa-credito>
    </v-dialog>

    <!-- Modificar Plan de Crédito  -->
    <v-dialog v-model="showModificarPlan" width="600" persistent>
      <app-modificador-plan-credito
        :Solicitud="solicitud"
        :Ok="modificacionOk"
        :Cancel="modificacionCancelada">
      </app-modificador-plan-credito>
    </v-dialog>

    <!-- Log Producto Dirigido  -->
    <v-dialog v-model="showLogProductoDirigido" width="600" persistent>
      <app-log-producto-dirigido
        :creditoId="solicitud.id"
        :Cancel="hideLogProductoDirigido">
      </app-log-producto-dirigido>
    </v-dialog>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";
import { format } from "date-fns";

import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      loading: false,
      loadingMotor: false,
      solicitud: { situacionCreditoId: 1 },
      listaSubEstados: [],
      selectedSubEstado: {},
      comentarios: "",
      tomadoPorOtroUsuario: false,
      showModificarPlan: false,
      showModificarCanalVenta: false,
      showLogProductoDirigido: false,
      listProductos: [],
      listProductosDisponibles: [],
      listPlanes: [],
      listPlanesDisponibles: [],
      listSituacionesCredito: [],
      cupo: 0,
      topeProducto: 0,
      cargosDirectos: null,
      infoRenovacion: null,
      headers: [
        // definición de columnas
        { text: "Fecha", value: "fecha", width: 140 },
        { text: "Acción", value: "accion" },
        { text: "Responsable", value: "responsable", width: 90 },
        { text: "Comentarios", value: "comentarios", width: 200 },
      ],
      options: {
        // definición de paginación
        sortDesc: [false],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      motorSiisaActivo: false,
      reevaluar: false,
      reevaluacion: {
        consultaId: null,
        ingresoMensual: 0,
        movimientos: 0,
        productoId: 0,
        entidadFinancieraId: 0,
      },
      creditosARenovar: [],
      listEntidadesFinancieras: [],
      listMotivosRechazo: [],
      listTiposLegajo: [
        { id: 1, nombre: "Smarter" },
        { id: 4, nombre: "DigitalMinds" },
        { id: 6, nombre: "Digital Argen" },
      ],
      model: { consultaCredito: null },
    };
  },
  async created() {
    this.motorSiisaActivo =
      this.$store.state.parametrosGenerales.conexionMotorSiisa;

    this.loadMotivosRechazo();
    this.loadSituacionesCredito();
    if (this.SolicitudId) this.tomar();
  },
  filters: {
    formatDate: function (value) {
      if (value) return format(value, "YYYY-MM-DD hh:MM");
    },
    formatMoney: function (value) {
      if (value) {
        if (Number.isInteger(value)) return "$ " + value + ".00";
        else return "$ " + value;
      }
    },
  },
  props: {
    SolicitudId: {
      type: String,
    },
    Visible: {
      type: Boolean,
      default: false,
    },
    FinAnalisis: Function,
  },
  computed: {
    ...mapGetters(["user", "DebugModeOn", "checkCanAccess"]),
    linkGuenoVisible: function () {
      if (!this.solicitud.linkGueno) return false;

      if (
        this.user.esComer &&
        (this.$store.state.parametrosGenerales.linkGuenoVisiblePara & 1) == 1
      )
        return true;
      if (
        this.user.esOnline &&
        (this.$store.state.parametrosGenerales.linkGuenoVisiblePara & 2) == 2
      )
        return true;
      if (
        this.user.esComercio &&
        (this.$store.state.parametrosGenerales.linkGuenoVisiblePara & 4) == 4
      )
        return true;
      if (
        this.user.esConcentrador &&
        (this.$store.state.parametrosGenerales.linkGuenoVisiblePara & 8) == 8
      )
        return true;

      return false;
    },
    linkDigiventuresVisible: function () {
      if (!this.solicitud.linkDigiventures) return false;

      if (
        this.user.esComer &&
        (this.$store.state.parametrosGenerales.linkDigiventuresisiblePara &
          1) ==
          1
      )
        return true;
      if (
        this.user.esOnline &&
        (this.$store.state.parametrosGenerales.linkDigiventuresisiblePara &
          2) ==
          2
      )
        return true;
      if (
        this.user.esComercio &&
        (this.$store.state.parametrosGenerales.linkDigiventuresisiblePara &
          4) ==
          4
      )
        return true;
      if (
        this.user.esConcentrador &&
        (this.$store.state.parametrosGenerales.linkDigiventuresisiblePara &
          8) ==
          8
      )
        return true;

      return false;
    },
    pasaAAprobado: function () {
      if (!this.selectedSubEstado.descripcion) return false;
      //console.log(this.selectedSubEstado.descripcion)
      return (
        this.solicitud.origenConsulta &&
        (this.selectedSubEstado.descripcion.toLowerCase().includes("aproba") ||
          this.selectedSubEstado.descripcion
            .toLowerCase()
            .includes("cupo modificado"))
      );
    },
    pasaARechazado: function () {
      if (!this.selectedSubEstado.descripcion) return false;
      //console.log(this.selectedSubEstado.descripcion)
      return this.selectedSubEstado.descripcion
        .toLowerCase()
        .includes("rechaza");
    },
    pasaALiquidado: function () {
      if (!this.selectedSubEstado.descripcion) return false;
      console.log(this.selectedSubEstado.descripcion);
      return this.selectedSubEstado.descripcion.toLowerCase().includes("liqui");
    },
    estadoAsignaCupo: function () {
      if (!this.selectedSubEstado.descripcion) return false;
      //console.log(this.selectedSubEstado.descripcion)
      return (
        this.selectedSubEstado.descripcion.toLowerCase().includes("aproba") ||
        this.selectedSubEstado.descripcion
          .toLowerCase()
          .includes("cupo modificado")
      );
    },
    infoconsultaCredito: function () {
      if (!this.model.consultaCredito) return null;

      var info =
        "El resultado de la Consulta fue " + this.model.consultaCredito.estado;

      if (
        this.model.consultaCredito.estado.includes("APROBADO") ||
        this.model.consultaCredito.estado.includes("INGRESADA")
      )
        if (this.model.consultaCredito.cupo == 0)
          info = info + ", pero requiere posterior análisis";
        else
          info = info + ", con un CUPO de $ " + this.model.consultaCredito.cupo;

      return info;
    },

    tieneRol() {
      return this.checkCanAccess("ap-reactivar-credito");
    },

    puedeVolverAtras() {
      return this.checkCanAccess("ap-volver-subestado-anterior");
    },
    solicitudAnuladaORechazada() {
      return (
        this.solicitud &&
        (this.solicitud.subEstadoId == 971 || this.solicitud.subEstadoId == 981)
      );
    },
    superarTopeMaximo: function () {
      return this.checkCanAccess("ap-superar-tope-maximo");
    },
    mostrarVerLogProductoDirigido: function () {
      return (
        this.solicitud.tipoProductoDescripcion &&
        this.solicitud.tipoProductoDescripcion
          .toUpperCase()
          .includes("DIRIGIDO CONSUMO") &&
        this.solicitud.subEstadoId >= 51
      );
    },
  },
  watch: {
    Visible: function () {
      if (this.Visible) {
        this.tomar();
      }
    },
    pasaAAprobado: async function () {
      if (this.pasaAAprobado) {
        await this.loadProductosDisponibles();
        await this.loadPlanesDisponibles();

        // copio los valores del resultado de la consulta
        if (this.model.consultaCredito) {
          this.cupo = this.model.consultaCredito.cupo;
          this.topeProducto = this.model.consultaCredito.topeProducto;
        }
      } else {
        this.cupo = 0;
        this.topeProducto = 0;
      }
    },
    reevaluar: async function () {
      if (this.reevaluar) {
        await this.loadProductosDisponibles();
        await this.loadEntidadesFinancieras();

        this.reevaluacion.consultaId = this.SolicitudId;
        this.reevaluacion.productoId = this.solicitud.productoId;
        this.reevaluacion.entidadFinancieraId =
          this.solicitud.entidadFinancieraId;
        this.reevaluacion.movimientos = 0;
      }
    },
    "solicitud.productoId": async function () {
      if (this.solicitud.productoId > 0) {
        this.loadPlanesDisponibles();
      }
    },
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    async tomar() {
      // veo si se puede tomar para anális
      this.loading = true;
      try {
        var params = {};
        params.creditoId = this.SolicitudId;
        params.tomado = true;

        this.loading = true;

        await http.post(
          "creditos/cambiarestadotomaanalisis",
          JSON.stringify({ parametros: params })
        );

        this.tomadoPorOtroUsuario = false;
      } catch (error) {
        this.tomadoPorOtroUsuario = true;
        // Error
        this.alertError(error);
      }

      this.cupo = 0;
      this.topeProducto = 0;

      this.comentarios = "";

      await this.load();
      this.loading = false;
    },
    async cancelarAnalisis() {
      // desmarco el crédito como tomado
      this.loading = true;
      try {
        var params = {};
        params.creditoId = this.SolicitudId;
        params.tomado = false;

        this.loading = true;

        await http.post(
          "creditos/cambiarestadotomaanalisis",
          JSON.stringify({ parametros: params })
        );
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async load() {
      this.loading = true;
      try {
        var result = await http.get(
          "Creditos/getinfoconsultaparaanalisis?id=" + this.SolicitudId
        );

        this.solicitud = result;

        console.log(this.solicitud);

        await this.loadSubEstadosProximos();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSubEstadosProximos() {
      this.loading = true;
      try {
        var result = await http.get(
          "Creditos/listsubestadosproximos?subEstadoId=" +
            this.solicitud.subEstadoId
        );

        this.listaSubEstados = result.list;
        this.selectedSubEstado = {};
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEntidadesFinancieras() {
      this.loading = true;
      try {
        var result = await http.get("entidadesfinancieras"); // traigo todas
        this.listEntidadesFinancieras = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async enviarComentarios() {
      if (this.comentarios == "") {
        this.alertWarning("Por favor, ingrese los comentarios a enviar.");
        return;
      }

      var params = {};
      params.creditoId = this.SolicitudId;
      params.comentarios = this.comentarios;

      this.loading = true;

      try {
        await http.post(
          "creditos/agregarcomentariosconsulta",
          JSON.stringify({ parametros: params })
        );

        if (
          confirm(
            "Se agregaron los comentarios ¿Desea mantener el caso en análisis?"
          )
        ) {
          this.cancelarYMantener();
        } else {
          this.cancelar();
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async reactivarCredito() {
      var params = {};
      params.creditoId = this.SolicitudId;

      this.loading = true;

      try {
        await http.post(
          "creditos/reactivarCredito",
          JSON.stringify({ creditoId: this.SolicitudId })
        );

        if (
          confirm(
            "Se paso el credito al estado anterior  ¿Desea mantener el caso en análisis?"
          )
        ) {
          this.cancelarYMantener();
        } else {
          this.cancelar();
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async confirmar() {
      if (!(this.selectedSubEstado.id > 0)) {
        this.alertWarning(
          "Por favor, seleccione a qué estado pasar el crédito antes de presionar Confirmar."
        );
        return;
      }

      if (this.pasaAAprobado) {
        // verifico que se hayan ingresado los valores necesarios
        if (this.cupo == 0) {
          this.alertWarning("Por favor, ingrese el cupo asignado.");
          return;
        }

        if (this.solicitud.productoId == 0) {
          this.alertWarning("Por favor, especifique el Producto.");
          return;
        }
      }

      if (
        this.topeProducto > this.solicitud.topeProducto &&
        !this.superarTopeMaximo
      ) {
        this.alertWarning(
          "Debe tener permisos para superar el Monto Máximo ($" +
            this.solicitud.topeProducto +
            ") permitido por el motor"
        );
        return;
      }

      if (this.pasaARechazado) {
        // verifico que se hayan ingresado los valores necesarios
        Vue.$log.debug(this.solicitud.motivoRechazoId);
        if (
          !this.solicitud.motivoRechazoId ||
          this.solicitud.motivoRechazoId == 0
        ) {
          this.alertWarning("Por favor, especifique el Motivo de Rechazo.");
          return;
        }

        //agrego el motivo a los comentarios
        this.comentarios +=
          "Motivo: " +
          this.listMotivosRechazo.find(
            (i) => i.id == this.solicitud.motivoRechazoId
          ).descripcion;
      }

      if (this.selectedSubEstado.id == 52 && this.solicitud.tipoLegajoId == 0) {
        this.alertWarning("Por favor, eliga un tipo de legajo.");
        return;
      }

      var params = {};
      params.creditoId = this.SolicitudId;
      params.subEstadoId = this.selectedSubEstado.id;
      params.motivo = this.comentarios;
      params.cupo = this.cupo;
      params.topeProducto = this.topeProducto;
      params.situacionId = this.solicitud.situacionCreditoId;
      params.productoId = this.solicitud.productoId;
      params.planId = this.solicitud.planId;
      params.motivoRechazoId = this.solicitud.motivoRechazoId;
      params.importeRenovacion = this.solicitud.importeRenovacion;
      params.tipoLegajoId = this.solicitud.tipoLegajoId;
      var tipoLegajo = this.listTiposLegajo.find(
        x => x.id == this.solicitud.tipoLegajoId
      );

      params.tipoLegajoNombre = tipoLegajo ? tipoLegajo.nombre : null;
      params.cargosDescuento = this.cargosDirectos;

      this.loading = true;
      //console.log(JSON.stringify({ parametros: params }));
      try {
        var result = await http.post(
          "creditos/cambiarestado",
          JSON.stringify({ parametros: params })
        );

        if (result.acciones) {
          var mensaje = "";
          for (let index = 0; index < result.acciones.length; index++) {
            const accion = result.acciones[index];
            mensaje = mensaje + accion + "<br>";
          }

          await this.$dialog.confirm({
            text: mensaje,
            title: "Se realizaron las siguientes acciones",
            actions: {
              false: "",
              true: {
                text: "OK",
                color: "primary",
              },
            },
            persistent: true, // Parece que no funciona...
          });
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;

      this.cancelar();
    },
    async cancelarYMantener() {
      this.FinAnalisis();
    },
    async cancelar() {
      if (!this.tomadoPorOtroUsuario) await this.cancelarAnalisis();

      this.FinAnalisis();

      this.reevaluar = false;
      this.reevaluacion = {
        consultaId: null,
        ingresoMensual: 0,
        movimientos: 0,
        productoId: 0,
        entidadFinancieraId: 0,
      };
      this.model.consultaCredito = null;
    },
    async loadSituacionesCredito() {
      this.loading = true;
      try {
        var result = await http.get("tipossituacioncredito");

        this.listSituacionesCredito = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadProductosDisponibles() {
      this.loading = true;
      try {
        var result = await http.get(
          "businesscore/productosdisponiblesparacredito" +
            "?empresaId=" +
            this.solicitud.empresaId +
            "&canalVentaId=" +
            this.solicitud.canalVentaId
        );

        this.listProductos = result.list;
        this.listProductosDisponibles = this.listProductos.filter(
          (p) => p.estaDisponible
        );
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadPlanesDisponibles() {
      this.loading = true;
      try {
        var result = await http.get(
          "businesscore/planesdisponiblesparacredito" +
            "?productoId=" +
            this.solicitud.productoId +
            "&empresaId=" +
            this.solicitud.empresaId +
            "&canalVentaId=" +
            this.solicitud.canalVentaId +
            "&calificacionPersonaId=" +
            this.solicitud.tipoCalificacionId
        );

        this.listPlanes = result.list;
        this.listPlanesDisponibles = this.listPlanes.filter(
          (p) => p.estaDisponible
        );
        if (result.list.length == 0) {
          this.solicitud.planId = 0;
          this.alertWarning(
            "El producto seleccionado no tiene Planes vigentes que estén disponibles. Utilice otro producto."
          );
        } else {
          this.solicitud.planId = result.list[0].planId;
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMotivosRechazo() {
      this.loading = true;
      try {
        var result = await http.get("motivosrechazo");

        this.listMotivosRechazo = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async reevaluarxMotor() {
      this.loadingMotor = true;
      this.model.consultaCredito = null;

      try {
        //console.log(this.reevaluacion);
        var result = await http.post(
          "creditos/reevaluarconsultamotor",
          JSON.stringify({ parametros: this.reevaluacion })
        );

        this.model.consultaCredito = result.entity;

        this.load(); //recargo los datos
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingMotor = false;
    },
    async modificacionOk() {
      this.load();
      this.showModificarCanalVenta = false;
      this.showModificarPlan = false;
    },
    async modificacionCancelada() {
      this.showModificarCanalVenta = false;
      this.showModificarPlan = false;
    },
    async hideLogProductoDirigido() {
      this.showLogProductoDirigido = false;
    },

    async calcularRenovacion(creditoId) {
      this.loading = true;
      try {
        var infoRenovacion = await http.get(
          "creditos/getinfocalculorenovacion?creditoId=" + creditoId
        );

        this.creditosARenovar.find((x) => x.id == creditoId).totalARenovar =
          infoRenovacion.totalARenovar;

        //Vue.set(credito, 'infoRenovacion', result); // agrega la prop como observable para que se actualice el DOM
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async buscarCreditosParaRenovar() {
      this.loading = true;
      try {
        var res = await http.get(
          "creditos/listcreditospararenovarorefinanciarporpersonayempresa?empresaId=" +
            this.solicitud.empresaId +
            "&personaId=" +
            this.solicitud.personaId
        );

        this.creditosARenovar = res.list.filter((x) => x.puedeRenovar);

        if (this.creditosARenovar.length == 0)
          this.alertWarning(
            "No se encontraron Créditos en condiciones de ser renovados"
          );
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
